<app-info-sidebar [infoData]="infoSidebarData" (closePanel)="onCloseSidenav()">
</app-info-sidebar>
